import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { styled, th, vui } from '../core';
import { activeClassName, cs, filterUndefined } from '../utils';
import { ButtonGroupProvider } from './context';
import { getInnerBorderColor } from './helpers';
export const ButtonGroupBase = styled.divBox `
  display: flex;

  // Border color between Buttons
  > *:not(:last-of-type):not(:focus) {
    border-right-color: ${p => th.color(p.innerBorderColor)};
  }

  // First Button
  > *:first-of-type:not(:last-of-type) {
    border-right-width: 1px;
  }

  // Middle Buttons
  > *:not(:first-of-type):not(:last-of-type) {
    border-left-width: 0px;
    border-right-width: 1px;
  }

  // Last Button
  > *:not(:first-of-type):last-of-type {
    border-left-width: 0px;
    margin-right: 0;
  }

  // Border color
  > *,
  *:hover {
    border-color: ${p => th.color(p.innerBorderColor)};
  }

  //
  > .${activeClassName}.vui-button-variant-secondaryDark {
    background-color: ${p => th.color('skyBlue.90')};
  }

  > .${activeClassName}.vui-button-variant-buttonGroupRounded {
    background-color: ${p => th.color('seaBlue.main')};
    color: ${p => th.color('white')};
  }

  > .vui-button-variant-buttonGroupRounded {
    border-left-width: 1px !important;
  }

  > .${activeClassName}.vui-button-variant-buttonGroupRounded:hover {
    background-color: ${p => th.color('seaBlue.20')};
  }

  > .${activeClassName}.vui-button-variant-buttonGroupRounded:active {
    background-color: ${p => th.color('seaBlue.35')};
  }
`;
/**
 * Organizes layout and display of multiple buttons. Controls border visual around and between the buttons.
 * Exposes some props to the children via context.
 */
export const ButtonGroup = vui((props, ref) => {
    const { className, disabled, innerBorderColor, size, variant = 'default', ...rest } = props;
    const context = useMemo(() => filterUndefined({
        disabled,
        size,
        variant: variant === 'default' ? 'secondaryDark' : 'buttonGroupRounded'
    }), [disabled, size, variant]);
    return (_jsx(ButtonGroupProvider, { value: context, children: _jsx(ButtonGroupBase, { className: cs('vui-buttonGroup', className, `vui-buttonGroup-variant-${variant}`), innerBorderColor: innerBorderColor ? innerBorderColor : getInnerBorderColor(props), ref, ...rest }) }));
});
ButtonGroup.displayName = 'ButtonGroup';
export default ButtonGroup;
